<template>
    <div class="content">
        <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                <nav-tabs-card>
                    <template slot="content">
                        <span class="md-nav-tabs-title" v-if="project">{{ project.name }}</span>
                        <md-tabs class="md-primary" md-alignment="right" md-sync-route>
                            <md-tab id="tab-details" md-label="Details" md-icon="bug_report" :to="/projects/ + $route.params.id" exact>
                                <project-details :tableData="tableData"></project-details>
                            </md-tab>
                            <md-tab id="tab-actuals" md-label="Actuals" md-icon="list" :to="/projects/ + $route.params.id + '/actuals'">
                                <project-actuals></project-actuals>
                            </md-tab>
                        </md-tabs>
                    </template>
                </nav-tabs-card>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "@/axios";
import ProjectDetails from "@/components/Project/Details.vue";
import ProjectActuals from "@/components/Project/Actuals";
import NavTabsCard from "@/components/Cards/NavTabsCard";

export default {
    name: "project",
    components: {
        ProjectDetails,
        ProjectActuals,
        NavTabsCard
    },
    data() {
        return {
            project: null,
            tableData: null,
            loading: false
        };
    },
    methods: {
        fetchDetails() {
            this.loading = true;
            axios.get("/projects/" + this.$route.params.id)
                .then(e => {
                    this.project = e.data.project;
                    this.tableData = e.data.tableData;
                    this.loading = false;
                });
        }
    },
    mounted() {
        this.fetchDetails();
    }
};
</script>
